import { render, staticRenderFns } from "./TableVideoRequestsAdmin.vue?vue&type=template&id=37adda61&scoped=true"
import script from "./TableVideoRequestsAdmin.js?vue&type=script&lang=js&external"
export * from "./TableVideoRequestsAdmin.js?vue&type=script&lang=js&external"
import style0 from "./TableVideoRequestsAdmin.vue?vue&type=style&index=0&id=37adda61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37adda61",
  null
  
)

export default component.exports